import { sendRequest } from './index';
import { API_SURVEY_URL } from '@core/constants/API';


export const SurveyCertificate = {
    GET: (queryParams) => {
        return sendRequest({
            url: `${API_SURVEY_URL}lectures/${queryParams}/certificates`,
            method: 'GET'
        });
    },
    POST: ({ id, payload }) => {
        return sendRequest({
            url: `${API_SURVEY_URL}lectures/${id}/certificates`,
            method: 'POST',
            body: payload
        });
    }
};